import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { TypographyWithEllipsis } from '@modules/common/components/TypographyWithEllipsis';
import { formatDashboardDateRange } from '@modules/dashboard/helpers';
import { EventRepeatRounded } from '@mui/icons-material';
import { Stack } from '@mui/material';

interface DashboardAnalysisSubtitleContentProps {
  duration: DateTimeRange;
  hasGlobalFilterDurationChangedFromDefault: boolean;
}

export const DashboardAnalysisSubtitleContent = ({
  duration,
  hasGlobalFilterDurationChangedFromDefault,
}: DashboardAnalysisSubtitleContentProps) => {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {hasGlobalFilterDurationChangedFromDefault && (
        <EventRepeatRounded
          color="info"
          sx={{
            fontSize: '1rem',
          }}
        />
      )}
      <TypographyWithEllipsis
        variant="caption"
        color={
          hasGlobalFilterDurationChangedFromDefault
            ? 'info.main'
            : 'text.secondary'
        }
      >
        {formatDashboardDateRange(duration)}
      </TypographyWithEllipsis>
    </Stack>
  );
};
